export default __webpack_public_path__ + "../images/apple-touch-icon-152x152.png";